<template>
  <div class="apprentice-list-container">
    <el-form @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :xl="8" :lg="8" :md="8" :sm="8">
          <el-row class="apprentice-title">
            <el-col>
              <span>Subject Areas</span>
            </el-col>
          </el-row>
          <el-form-item
            ref="subjectarea"
            :error="retrieveFieldError(this.$props.ModelState, 'subjectAreaId')"
          >
            <el-row
              class="apprentice-maintenance-list"
              v-bind:style="
                this.$props.Disabled
                  ? { 'pointer-events': 'none', opacity: '0.4' }
                  : {}
              "
            >
              <el-col>
                <div
                  :class="[
                    subject.isActive
                      ? 'maintenance-item is-active'
                      : 'maintenance-item'
                  ]"
                  v-for="(subject, index) in subjects"
                  :key="index"
                  @click="subjectAreaSelected(subject, true)"
                >
                  <span>{{ subject["name"] }} </span>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :xl="8" :lg="8" :md="8" :sm="8">
          <el-row class="apprentice-title">
            <el-col>
              <span>Levels</span>
            </el-col>
          </el-row>
          <el-form-item
            ref="level"
            :error="retrieveFieldError(this.$props.ModelState, 'level')"
          >
            <el-row
              class="apprentice-maintenance-list"
              v-bind:style="
                this.$props.Disabled
                  ? { 'pointer-events': 'none', opacity: '0.4' }
                  : {}
              "
            >
              <el-col>
                <div
                  :class="[
                    level.isActive
                      ? 'maintenance-item is-active'
                      : 'maintenance-item'
                  ]"
                  v-for="(level, index) in levels"
                  :key="index"
                  @click="levelSelected(level)"
                >
                  <span>Level {{ level.name.toString() }} </span>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :xl="8" :lg="8" :md="8" :sm="8">
          <el-row class="apprentice-title">
            <el-col>
              <span>Pathways</span>
            </el-col>
          </el-row>
          <el-form-item
            ref="pathway"
            :error="retrieveFieldError(this.$props.ModelState, 'pathwayId')"
          >
            <el-row
              class="apprentice-maintenance-list"
              v-bind:style="
                this.$props.Disabled
                  ? { 'pointer-events': 'none', opacity: '0.4' }
                  : {}
              "
            >
              <el-col>
                <div
                  :class="[
                    pathway.isActive
                      ? 'maintenance-item is-active'
                      : 'maintenance-item'
                  ]"
                  v-for="(pathway, index) in pathways"
                  :key="index"
                  @click="pathwaySelected(pathway)"
                >
                  <span>{{ pathway.name }} </span>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "ApprenticeCriteria",
  props: {
    SubjectAreaId: {
      type: String,
      default: ""
    },
    Level: {
      type: Number,
      default: null
    },
    PathwayId: {
      type: String,
      default: ""
    },
    ModelState: {
      type: Object,
      default() {
        return {};
      }
    },
    Disabled: {
      type: Boolean,
      default: false
    },
    RemoveNoCriteria: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      subjects: [],
      levels: [],
      pathways: [],
      selectedSubject: {},
      selectedLevel: {},
      selectedPathway: {}
    };
  },
  created() {
    this.getSubjectAreas();
  },
  methods: {
    getSubjectAreas() {
      this.$store
        .dispatch(
          this.$props.RemoveNoCriteria
            ? "apprentice/getSubjectAreaListWithCriteria"
            : "apprentice/getSubjectAreas"
        )
        .then(res => {
          this.subjects = res.map(c => {
            return { ...c, isActive: false };
          });
          this.setValues();
        });
    },
    subjectAreaSelected(subject, isResetValues) {
      if (this.selectedSubject.id === subject.id) return;
      this.addLevels(subject, () => {
        if (this.$props.Level !== "" && this.$props.Level !== null) {
          this.levelSelected(
            this.levels.find(c => c.name == this.$props.Level)
          );
        }
      });

      subject.isActive = true;
      this.selectedSubject.isActive = false;
      this.selectedSubject = subject;
      this.$emit("subject-area-selected", {
        subject: subject,
        isResetValues: isResetValues
      });

      if (this.$props.ModelState["SubjectAreaId"]) {
        delete this.$props.ModelState["SubjectAreaId"];
      }

      if (!this.$props.RemoveNoCriteria) {
        this.getPathways(
          subject,
          this.$props.PathwayId !== "" ? this.$props.PathwayId : "",
          ""
        );
      }
    },
    addLevels(subject, action) {
      this.levels = [];

      if (this.$props.RemoveNoCriteria) {
        this.$store
          .dispatch("apprentice/getLevelsWithCriteria", subject.id)
          .then(res => {
            this.levels = res.map(c => {
              return { name: c, isActive: false };
            });
            action();
          });
      } else {
        const max = subject.noOfLevels;
        for (let i = 2; i <= max; i += 1) {
          this.levels.push({ name: i, isActive: false });
        }
        action();
      }
    },
    getPathways(subject, pathwayId, level) {
      this.pathways = [];

      this.$store
        .dispatch(
          this.$props.RemoveNoCriteria
            ? "apprentice/getPathwaysWithCriteria"
            : "apprentice/getPathways",
          this.$props.RemoveNoCriteria
            ? { subjectArea: subject.id, level: level }
            : subject.id
        )
        .then(res => {
          this.pathways = res.map(c => {
            return { ...c, isActive: false };
          });
          this.$emit("pathways-loaded", this.pathways.length);

          if (pathwayId !== null) {
            this.pathwaySelected(this.pathways.find(c => c.id == pathwayId));
          }
        });
    },
    levelSelected(level) {
      if (this.selectedLevel === level) return;

      level.name = level.name;
      level.isActive = true;
      this.selectedLevel.isActive = false;
      this.selectedLevel = level;
      this.$emit("level-selected", { level: level });
      if (this.$props.ModelState["Level"]) {
        delete this.$props.ModelState["Level"];
      }

      if (this.$props.RemoveNoCriteria) {
        this.getPathways(
          this.selectedSubject,
          this.$props.PathwayId !== "" ? this.$props.PathwayId : "",
          level.name
        );
      }
    },
    pathwaySelected(pathway) {
      if (this.selectedPathway === pathway) return;
      pathway.isActive = true;
      this.selectedPathway.isActive = false;
      this.selectedPathway = pathway;
      this.$emit("pathway-selected", { pathway: pathway });

      if (this.$props.ModelState["PathwayId"]) {
        delete this.$props.ModelState["PathwayId"];
      }
    },
    setValues() {
      if (!!this.$props.SubjectAreaId) {
        const subject = this.subjects.find(
          c => c.id == this.$props.SubjectAreaId
        );
        this.subjectAreaSelected(subject, false);
      }
    }
  },
  updated() {
    var elements = document.getElementsByClassName(
      "maintenance-item is-active"
    );
    for (let index = 0; index < elements.length; index++) {
      const element = elements[index];
      element.scrollIntoView();
    }
  }
};
</script>
